var map = {
	"./administrativo.svg": 3142,
	"./asesoramiento.svg": 9045,
	"./daños.svg": 1982,
	"./deportivo.svg": 6735,
	"./informatico.svg": 1468,
	"./intelectual.svg": 7670,
	"./notarial.svg": 4409,
	"./societario.svg": 2691,
	"./sucesorio.svg": 7655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 695;